<web-design-system-modal
  [headline]="'trade.create.check-experience-and-ftg.showExperienceNoticeKrypto.headline' | transloco"
  (dismiss)="modal.close('cancel')"
  data-zid="experience-container"
>
  <div class="row">
    <div class="col-12 mb-4">
      {{ 'trade.create.check-experience-and-ftg.showExperienceNoticeKrypto.text' | transloco }}
    </div>
    <div
      class="col-12 col-sm-6 d-flex pt-2 pt-sm-0 order-1 order-sm-0 justify-content-center justify-content-sm-start text-size-xlarge align-items-center"
    >
      @if (showCancelButton) {
        <a class="link link-secondary cursor-pointer" (click)="modal.close('cancel')">
          {{ 'trade.create.check-experience-and-ftg.showExperienceNoticeKrypto.cancel' | transloco }}
        </a>
      }
    </div>
    <div class="col-12 col-sm-6 d-flex justify-content-end pt-2 pt-sm-0 order-0 order-sm-1">
      <web-design-system-button size="small" (click)="modal.close('experienceNoticeKrypto')">
        {{ 'trade.create.check-experience-and-ftg.showExperienceNoticeKrypto.proceed' | transloco }}
      </web-design-system-button>
    </div>
  </div>
</web-design-system-modal>
